import type { Color } from '@precon-tools-suite-by-shared/precon-graphql-types';
import type { ColorTint } from './normalizeColor';

function colorClassSuffix(color: Color, tint: ColorTint = '500'): string {
    return `${color.toLowerCase()}-${tint}`;
}

export function colorClass(
    prefix: string,
    color: Color,
    tint?: ColorTint
): string;
export function colorClass(
    prefix: string,
    color: Color,
    tint: ColorTint | 'none'
): string | undefined;
export function colorClass(
    prefix: string,
    color: Color,
    tint: ColorTint | 'none' = '500'
): string | undefined {
    if (tint === 'none') {
        return undefined;
    } else {
        return `${prefix}-${colorClassSuffix(color, tint)}`;
    }
}

export function textColorClass(color: Color, tint?: ColorTint): string;
export function textColorClass(
    color: Color,
    tint: ColorTint | 'none'
): string | undefined;
export function textColorClass(
    color: Color,
    tint: ColorTint | 'none' = '500'
): string | undefined {
    return colorClass('text', color, tint);
}

export function bgColorClass(color: Color, tint?: ColorTint): string;
export function bgColorClass(
    color: Color,
    tint: ColorTint | 'none'
): string | undefined;
export function bgColorClass(
    color: Color,
    tint: ColorTint | 'none' = '500'
): string | undefined {
    return colorClass('bg', color, tint);
}

export function borderColorClass(color: Color, tint?: ColorTint): string;
export function borderColorClass(
    color: Color,
    tint: ColorTint | 'none'
): string | undefined;
export function borderColorClass(
    color: Color,
    tint: ColorTint | 'none' = '500'
): string | undefined {
    return colorClass('bg', color, tint);
}

export interface ColorClassResolver {
    (prefix: string, tint?: ColorTint): string;
    (prefix: string, tint: ColorTint | 'none'): string | undefined;
    text(tint?: ColorTint): string;
    text(tint: ColorTint | 'none'): string | undefined;
    bg(tint?: ColorTint): string;
    bg(tint: ColorTint | 'none'): string | undefined;
    border(tint?: ColorTint): string;
    border(tint: ColorTint | 'none'): string | undefined;
}

export function colorClassResolver(color: Color): ColorClassResolver {
    const resolver = (prefix: string, tint: ColorTint | 'none' = '500') =>
        colorClass(prefix, color, tint);

    return Object.assign(resolver, {
        text: (tint: ColorTint | 'none' = '500') => resolver('text', tint),
        bg: (tint: ColorTint | 'none' = '500') => resolver('bg', tint),
        border: (tint: ColorTint | 'none' = '500') => resolver('border', tint),
    }) as ColorClassResolver;
}
